import { render, staticRenderFns } from "./order-support.vue?vue&type=template&id=82700d82&"
import script from "./order-support.vue?vue&type=script&lang=js&"
export * from "./order-support.vue?vue&type=script&lang=js&"
import style0 from "./order-support.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82700d82')) {
      api.createRecord('82700d82', component.options)
    } else {
      api.reload('82700d82', component.options)
    }
    module.hot.accept("./order-support.vue?vue&type=template&id=82700d82&", function () {
      api.rerender('82700d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/order-support.vue"
export default component.exports